<template>
    <Row class="full-y">
        <Table :max-height="maxHeight" ref="table" :loading="loading" :data="list" :columns="columns"></Table>

        <!-- 弹框 -->
        <template>
            <lg-modal :show="modal.show" :title="modal.title" @on-cancel="modal.show=false" :confirm-text="$t('l.assigned_to')" @on-submit="onSubmit"
                      @on-visible-change="(e)=>{modal.show=e}">
                <Row>
                    <Select id="my-select" :placeholder="$t('l.remark228')"
                            v-model="modal.search.band_user_ids"
                            filterable
                            :max-tag-count="3"
                            multiple
                            remote
                            :remote-method="remoteSearchUser"
                            @on-change="changedOption"
                            :loading="modal.loading">
                        <Option v-for="(member) in modal.search.options" :value="member.id" :key="member.id">
                            {{member.realname}}({{member.mobile}})
                        </Option>
                    </Select>
                </Row>
                <Row  class="margin-top-10">
                    <h3>{{$t("l.relationship_structure")}}</h3>
                </Row>
                <!-- 绑定用户的树形结构 -->
                <Tree class="margin-top-10" style="overflow-x: hidden;overflow-y: auto;height: 100%;max-height: 500px;overflow-y: auto;" :data="modal.tree.data"
                      :render="renderTree"
                      :empty-text="$t('l.remark230')"></Tree>
            </lg-modal>
        </template>
    </Row>
</template>

<script>
    import util from '@/libs/util';
    import lgModal from "../../my-components/lg-modal";

    export default {
        name: "visible-device",
        components: {lgModal},
        props: {
            list: Array,
            loading: Boolean,
            offsetHeight: Number,
            currentCompany:Number
        },
        data() {
            return {
                maxHeight: 0,
                modal: {
                    show: false,
                    title: '',
                    loading: false,
                    search: {
                        options: [],
                        band_user_ids: [],

                    },
                    currentDeviceId: 0,
                    tree: {
                        data: []
                    }
                }
            }
        },
        methods: {
            remoteSearchUser(value) {
                // if (!value.trim()) return;
                this.modal.loading = true;
                util.ajax.get('/user/searchoption', {
                    params: {
                        table: 't_user',
                        field: 'realname,mobile',
                        value: value,
                        companyId:this.currentCompany
                    }
                }).then(res => {
                    this.modal.loading = false;
                    this.modal.search.options = res.data;
                    if (res.data && res.data.length) {
                        res.data.forEach(elem =>{
                            if (elem.mobile) {
                                elem.mobile = elem.mobile.substr(0,3) + "****" + elem.mobile.substr(7)
                            }
                            this.usersMap[elem.id] = elem;
                        })

                    }
                })
            },
            changedOption(value) {

            },
            onSubmit() {
                let list = [];
                if (this.modal.search.band_user_ids.length) {
                    this.modal.search.band_user_ids.forEach(elem =>{
                        if (this.usersMap[elem]){
                            list.push(this.usersMap[elem]);
                        }
                    })
                }
                if (!list.length) {
                    this.$Message.warning(this.$t("l.remark229"));
                   return;
                }
                util.ajax.post("user/banduser", {
                    id: this.modal.currentDeviceId,
                    band_user_ids: list || [],
                }).then(res => {
                    if (!res.code) {
                        this.$Message.success(this.$t("l.success"));
                        this.refresh();
                    }
                })
                this.modal.show = false;
            },
            refresh() {
                this.$emit("refresh")
            },
            renderTree (h, { root, node, data }) {
                return h('span', {
                        style: {
                            display: 'inline-block',
                            width: '100%'
                        }
                    }, [
                        h('span', [
                            h('Icon', {
                                props: {
                                    type: 'md-person',
                                    size:'14'
                                },
                                style: {
                                    marginRight: '8px'
                                }
                            }),
                            h('span', `${data.realname}（${data.mobile}）`)
                        ]),
                        h('span', {
                            style: {
                                display: 'inline-block',
                                float: 'right',
                                marginRight: '32px'
                            }
                        }, [
                            h('Button', {
                                on: {
                                    click: () => {
                                        this.remoteSearchUser();
                                        util.ajax.get(`user/unbanduser?user_id=${data.user_id}&device_id=${data.device_id}`).then(res=>{
                                            if (!res.code){
                                                this.$Message.success(this.$t("l.success"));
                                                this.refresh();
                                                this.modal.show=false;
                                            }
                                        })
                                    }
                                }
                            },this.$t("l.unassigned_to")),
                        ])
                    ]);
                },
        },
        created() {
            this.remoteSearchUser();
        },
        computed: {
            columns() {
              let conmpany = this.$store.state.user.user.company;
              let isZhongFuCompany =  conmpany.id === 154 || conmpany.pid === 154;
                return [
                    {
                        type: 'selection',
                        width: 60,
                        align: 'center'
                    },
                    {
                        title: "ID",
                        key: 'id',
                        align: 'center'
                    },
                    {
                        title: this.$t('l.elevator_name'),
                        key: 'name',
                        align: 'center'
                    },
                    {
                        title: isZhongFuCompany?this.$t('l.device_unique_id'):this.$t('l.device_number'),
                        key: 'code',
                        width: 170,
                        align: 'center'
                    },
                    {
                        title: this.$t('l.terminal'),
                        key: 'terminal_id',
                        width: 170,
                        align: 'center'
                    },
                    {
                        title: this.$t('l.device_address'),
                        key: 'address',
                        align: 'center'
                    },
                    {
                        title: this.$t('l.operation'),
                        align: 'center',
                        width: 240,
                        render: (h, param) => {
                          if(this.$ifauth('btn_assigned_lift') || this.$store.state.user.isROOT){
                            return h('div', [
                              h('Button', {
                                props: {
                                  type: 'primary',
                                },
                                style: {
                                  marginRight: "8px",
                                  borderLeftColor: ''
                                },
                                on: {
                                  click: () => {
                                    this.modal.search.band_user_ids = [];
                                    this.modal.currentDeviceId = param.row.id;
                                    this.modal.show = true;
                                    this.modal.title = this.$t("l.band_unband_user");
                                    //    获取当前电梯的绑定用户树形结构
                                    util.ajax.get("device/getbanduser?device_id=" + param.row.id).then(res => {
                                      if (!res.code && res.data) {
                                        this.modal.tree.data = res.data;
                                        // 当前用户只能拥有直属下级用户
                                        // this.modal.search.band_user_ids = res.data.map(elem=>elem.id);
                                      }
                                    })
                                  }
                                }
                              }, this.$t('l.band_unband_user')),
                            ]);
                          }else{
                            return h('div', [
                              h('span', {
                                props: {
                                  type: 'primary',
                                },
                                style: {
                                  marginRight: "8px",
                                  borderLeftColor: ''
                                },
                                on: {
                                  click: () => {
                                    this.modal.search.band_user_ids = [];
                                    this.modal.currentDeviceId = param.row.id;
                                    this.modal.show = true;
                                    this.modal.title = this.$t("l.band_unband_user");
                                    //    获取当前电梯的绑定用户树形结构
                                    util.ajax.get("device/getbanduser?device_id=" + param.row.id).then(res => {
                                      if (!res.code && res.data) {
                                        this.modal.tree.data = res.data;
                                        // 当前用户只能拥有直属下级用户
                                        // this.modal.search.band_user_ids = res.data.map(elem=>elem.id);
                                      }
                                    })
                                  }
                                }
                              }, "-"),
                            ]);
                          }

                        }
                    }
                ]
            },
            usersMap(){
                return {};
            }
        },
        watch: {
            offsetHeight(nv) {
                this.maxHeight = nv - 54 - 30;
            }
        }
    }
</script>

<style scoped>

</style>